import { AccessLevel, UserApiKeyDataSerialized, UserApiKeySerialized } from '@playq/octopus2-auth';

import { ITableQuery } from '/shared/Table/interfaces';

import { KeyCreationDialogTogglingHandler, KeyFormSubmissionHandler } from '../types';

export interface IApiKeyFormProps {
  isKeyCreationBeingProcessed: boolean;
  isKeyRegenerationBeingProcessed: boolean;
  defaultKeyAccessLevel: AccessLevel;
  tableQueryToPerformAfterKeyCreation: ITableQuery<string>;
  keyFormSubmissionHandler: KeyFormSubmissionHandler;
  keyDataToCopy: UserApiKeySerialized | null;
  keyCreationDialogTogglingHandler: KeyCreationDialogTogglingHandler;
  mode?: 'create' | 'regenerate';
  initialValue?: UserApiKeyDataSerialized;
  handleCloseRegenerateDialog?: () => void;
}

export interface ISelectAccessLevelOptions {
  None: AccessLevel.None;
  Read: AccessLevel.Read;
  Write: AccessLevel.Write;
  ['Write Live']: AccessLevel.WriteLive;
}

export interface ICurrentAccessLevelOption {
  label: keyof ISelectAccessLevelOptions;
  value: AccessLevel;
}

export enum ExpirationLabels {
  days7 = '7 days',
  days30 = '30 days',
  days60 = '60 days',
  days90 = '90 days',
  months6 = '6 month',
  year1 = '1 year',
  noExpiration = 'No expiration',
  custom = 'Custom',
}
